import { render, staticRenderFns } from "./AnnouncePage.vue?vue&type=template&id=32d770fa&scoped=true"
import script from "./AnnouncePage.vue?vue&type=script&lang=js"
export * from "./AnnouncePage.vue?vue&type=script&lang=js"
import style0 from "./AnnouncePage.vue?vue&type=style&index=0&id=32d770fa&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d770fa",
  null
  
)

export default component.exports